var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBriefcaseOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7396 3.00894V2.04894C10.7396 1.69566 10.4529 1.40894 10.0996 1.40894H6.89964C6.54636 1.40894 6.25964 1.69566 6.25964 2.04894V3.00894",
    stroke: "currentColor",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.875 14.209V9.96903C1.05173 10.0555 1.25028 10.104 1.46 10.104H15.54C15.7497 10.104 15.9483 10.0555 16.125 9.96903V14.209C16.125 14.5312 15.8622 14.794 15.54 14.794H1.46C1.13783 14.794 0.875 14.5312 0.875 14.209Z",
    stroke: "currentColor",
    strokeWidth: 0.75
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.46 3.38428H15.54C15.8622 3.38428 16.125 3.6471 16.125 3.96928V8.12928C16.125 8.45145 15.8622 8.71428 15.54 8.71428H8.9599C9.28929 8.54649 9.515 8.20414 9.515 7.80928C9.515 7.24889 9.06039 6.79428 8.5 6.79428C7.93961 6.79428 7.485 7.24889 7.485 7.80928C7.485 8.20414 7.71071 8.54649 8.0401 8.71428H1.46C1.13783 8.71428 0.875 8.45145 0.875 8.12928V3.96928C0.875 3.6471 1.13783 3.38428 1.46 3.38428Z",
    stroke: "currentColor",
    strokeWidth: 0.75
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBriefcaseOutline);
export default __webpack_public_path__ + "static/media/briefcase-outline.37675745076eb7e973ab9f5994b1cbce.svg";
export { ForwardRef as ReactComponent };